import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reingestorDeletePromise, DeleteSchema } from 'src/utils/api';
import { QUERY_KEY_MAP } from 'src/constants/query-key';
import { useNotification } from 'src/hooks';
import { useTranslation } from 'react-i18next';

export const useReingestorDelete = () => {
  const queryClient = useQueryClient();
  const { enqueueErrorNotification, enqueueSuccessNotification } = useNotification();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: reingestorDeletePromise,
  });
  const { t } = useTranslation();

  const submitDeleteTaskAsync = async (param: DeleteSchema) => {
    try {
      const result = await mutateAsync({
        ...(param || {}),
      });

      if (!result) {
        enqueueErrorNotification(t('uilabel.delete.submit.failed'));
        return result;
      }

      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useListTasks],
      });

      enqueueSuccessNotification(t('uilabel.delete.submit.success'));
      return result;
    } catch (e) {
      enqueueErrorNotification(t('uilabel.delete.submit.failed'));

      console.error('~ file: useReingestorDelete.ts:16 ~ submitDeleteTaskAsync ~ e:', e);
      return false;
    }
  };

  return {
    submitDeleteTaskAsync,
    isLoading: isPending,
  };
};
